var map = {
	"./admins/admins.module": [
		"./src/app/admins/admins.module.ts",
		"admins.module"
	],
	"./apps/apps.module": [
		"./src/app/apps/apps.module.ts",
		"common",
		"apps.module"
	],
	"./authentication/authentication.module": [
		"./src/app/authentication/authentication.module.ts",
		"common",
		"authentication.module"
	],
	"./cambio-impianto-carta/cambio-impianto-carta.module": [
		"./src/app/cambio-impianto-carta/cambio-impianto-carta.module.ts",
		"cambio-impianto-carta.module"
	],
	"./carte/carta.module": [
		"./src/app/carte/carta.module.ts",
		"common",
		"carta.module"
	],
	"./charts/chartslib.module": [
		"./src/app/charts/chartslib.module.ts",
		"common",
		"chartslib.module"
	],
	"./clients/clients.module": [
		"./src/app/clients/clients.module.ts",
		"clients.module"
	],
	"./costo-servizi/costo-servizi.module": [
		"./src/app/costo-servizi/costo-servizi.module.ts",
		"costo-servizi.module"
	],
	"./crea-carta-ricarica/crea-carta-ricarica.module": [
		"./src/app/crea-carta-ricarica/crea-carta-ricarica.module.ts",
		"common",
		"crea-carta-ricarica.module"
	],
	"./dashboards/dashboards.module": [
		"./src/app/dashboards/dashboards.module.ts",
		"common",
		"dashboards.module"
	],
	"./datatables/datatables.module": [
		"./src/app/datatables/datatables.module.ts",
		"datatables.module"
	],
	"./estratto-conto-crediti/estratto-conto-crediti.module": [
		"./src/app/estratto-conto-crediti/estratto-conto-crediti.module.ts",
		"estratto-conto-crediti.module"
	],
	"./forms/forms.module": [
		"./src/app/forms/forms.module.ts",
		"common",
		"forms.module"
	],
	"./gestione-casse-banner/gestione-casse-banner.module": [
		"./src/app/gestione-casse-banner/gestione-casse-banner.module.ts",
		"common",
		"gestione-casse-banner.module"
	],
	"./gestione-casse-crediti/gestione-casse-crediti.module": [
		"./src/app/gestione-casse-crediti/gestione-casse-crediti.module.ts",
		"common",
		"gestione-casse-crediti.module"
	],
	"./gestione-listini/gestione-listini.module": [
		"./src/app/gestione-listini/gestione-listini.module.ts",
		"common",
		"gestione-listini.module"
	],
	"./gestisci-servizi-cash/gestisci-servizi-cash.module": [
		"./src/app/gestisci-servizi-cash/gestisci-servizi-cash.module.ts",
		"common",
		"gestisci-servizi-cash.module"
	],
	"./implants/implants.module": [
		"./src/app/implants/implants.module.ts",
		"common",
		"implants.module"
	],
	"./material-component/material.module": [
		"./src/app/material-component/material.module.ts",
		"material.module"
	],
	"./offerte/offerte.module": [
		"./src/app/offerte/offerte.module.ts",
		"offerte.module"
	],
	"./operatori/operatori.module": [
		"./src/app/operatori/operatori.module.ts",
		"common",
		"operatori.module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"pages.module"
	],
	"./resetta-carta/resetta-carta.module": [
		"./src/app/resetta-carta/resetta-carta.module.ts",
		"resetta-carta.module"
	],
	"./ricarica-carta/ricarica-carta.module": [
		"./src/app/ricarica-carta/ricarica-carta.module.ts",
		"common",
		"ricarica-carta.module"
	],
	"./servizi/servizi.module": [
		"./src/app/servizi/servizi.module.ts",
		"servizi.module"
	],
	"./settings/settings.module": [
		"./src/app/settings/settings.module.ts",
		"settings.module"
	],
	"./statistiche-vendita-crediti/statistiche-vendita-crediti.module": [
		"./src/app/statistiche-vendita-crediti/statistiche-vendita-crediti.module.ts",
		"common",
		"statistiche-vendita-crediti.module"
	],
	"./storico-movimenti/storico-movimenti.module": [
		"./src/app/storico-movimenti/storico-movimenti.module.ts",
		"common",
		"storico-movimenti.module"
	],
	"./tables/tables.module": [
		"./src/app/tables/tables.module.ts",
		"tables.module"
	],
	"./users/users.module": [
		"./src/app/users/users.module.ts",
		"common",
		"users.module"
	],
	"./widgets/widgets.module": [
		"./src/app/widgets/widgets.module.ts",
		"widgets.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main